import _extends from "@babel/runtime/helpers/esm/extends";
import { createTheme, lighten } from '@mui/material/styles';
var augmentColorMui = createTheme().palette.augmentColor;
export default function augmentColor(options) {
  var color = augmentColorMui(options);
  var A700 = lighten(color.light, 0.2);
  var A400 = lighten(color.light, 0.5);
  var A200 = lighten(color.light, 0.7);
  var A100 = lighten(color.light, 0.9);
  return _extends({}, color, {
    // Generate the full set of Material Design color stops
    // By default, MUI's palette only generates light, main, dark, and contrastText from a single main color.
    // The full set of stops (100, 200, etc.) are only present if you use a predefined color object (like blue, red, etc. from @mui/material/colors)
    900: color.dark,
    800: color.main,
    700: A700,
    600: A700,
    500: A400,
    400: A400,
    300: A200,
    200: A200,
    100: A100,
    50: A100,
    A700: A700,
    A400: A400,
    A200: A200,
    A100: A100
  });
}